import {Divider, FormHelperText, MenuItem, TextField, TextFieldPropsSizeOverrides} from "@mui/material";
import {OverridableStringUnion} from "@mui/types";
import {QueryConstraint, QueryFieldFilterConstraint} from "firebase/firestore";
import {ChangeEvent, ReactNode, useEffect, useState} from "react";
import FirebaseQuery from "../../Util/firebaseQuery";
type Params = {
    value?: string|string[],
    onChange?: (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void,
    children?: ReactNode[],
    disabled?: boolean,
    required?: boolean,
    multiple?: boolean,
    name?: string,
    path?: [(string | string[]), (QueryConstraint | QueryConstraint[] | QueryFieldFilterConstraint | QueryFieldFilterConstraint[] | undefined)],
    size?: OverridableStringUnion<"small" | "medium", TextFieldPropsSizeOverrides>,
    label?: string,
    sx?: {[key:string]: unknown},
    errorText?: string,
    id?: string,
    formatMenuItems?: (data: {[key: string]: unknown}) => ReactNode,
    divider?: boolean
}

export default function Dropdown({id, value, onChange, children, divider, disabled, required, multiple, name, path, size="small", label, sx, errorText, formatMenuItems}:Params) {
    const [selected, setSelected] = useState(value ? multiple ? Array.isArray(value) ? value : value.split(",") : value : undefined);
    const [error, setError] = useState(false);
    const [items, setItems] = useState(children);

    const firebaseQuery = new FirebaseQuery();

    const handleChange = (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        console.log("ONCHANGE DROPDOWN", id, e);
        if (e.target.value === "" && required) {
            setError(true);
        } else {
            setError(false);
        }
        setSelected(e.target.value);
        onChange && onChange(e);
    };

    useEffect(() => {
        setSelected(multiple ? typeof value === "string" ? value.split(",") : value : (value || undefined));
    }, [multiple, value]);

    useEffect(() => {
        if (!path) {
            setItems(children || undefined);
        }
    }, [children, name]);

    useEffect(() => {
    // Get items from database if none are given as children.

        if (!path) {
            return;
        }
        console.log("get items");
        firebaseQuery.getDocsWhere(...path).then((collectionResult: any) => {
            const i = Object.entries(collectionResult as {[key:string]: {name: string}}).map(([k, v]) => {
                return (formatMenuItems ? formatMenuItems({id: k, ...v}) : <MenuItem value={k}>{v.name}</MenuItem>);
            });
            setItems(children ? [...i, children] : i);
        });
    }, [path?.[0]]);

    useEffect(() => {
        if (path) {
            console.log("items", items);
        }
    }, [items]);

    // Helper function to format selected values with dividers
    const formatSelectedValues = () => {
        if (!divider || !Array.isArray(selected) || !items) {
            return;
        }
        console.log(items);
        return selected.map((val, index) => (
            <div key={index}>
                {items.find((item) => (item as any)?.props.value === val)}
                {index < selected.length - 1 && divider && <Divider />}
            </div>
        ));
    };

    return (
        <TextField fullWidth
            select
            SelectProps={{
                multiple: multiple,
                renderValue: divider && Array.isArray(selected) ? () => formatSelectedValues() : undefined,
            }}
            value={((multiple && !selected) ? [] : selected)}
            onBlur={handleChange}
            onChange={handleChange}

            {...{id, sx, label, disabled, size, name, required, error}}
        >
            {items as any}
            <FormHelperText error={error}>{error ? (errorText || "Required") : ""}</FormHelperText>
        </TextField>
    );
}
